import { NavLink } from "@mantine/core";
import { Link } from "gatsby";
import React from "react";

import * as styles from "./SidebarContent.module.css";

interface NavPage {
  id: string;
  title: string;
}

interface NavSection {
  title: string;
  pages: NavPage[];
}

interface SidebarContentProps {
  sections: NavSection[];
  currentPageId: string;
  /** Base URL path for this docs section, e.g. "/bob-builder" */
  basePath: string;
  /** Page id that maps to basePath + "/". Defaults to "home" */
  homePageId?: string;
  onNavigate?: () => void;
}

export function SidebarContent({
  sections,
  currentPageId,
  basePath,
  homePageId = "home",
  onNavigate,
}: SidebarContentProps) {
  return (
    <>
      {sections.map((section) => (
        <div key={section.title}>
          <div className={styles.sectionTitle}>{section.title}</div>
          {section.pages.map((page) => {
            const isActive = page.id === currentPageId;
            const href =
              page.id === homePageId
                ? `${basePath}/`
                : `${basePath}/${page.id}/`;
            return (
              <NavLink
                key={page.id}
                label={page.title}
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                component={Link as any}
                to={href}
                active={isActive}
                onClick={onNavigate}
                styles={{
                  label: {
                    fontSize: 14,
                    color: isActive
                      ? "var(--mantine-color-fontLight-5)"
                      : "var(--mantine-color-fontLightSecondary-5)",
                    fontWeight: isActive ? 600 : 400,
                  },
                  root: {
                    backgroundColor: isActive
                      ? "rgba(177, 54, 54, 0.15)"
                      : "transparent",
                    borderRadius: "var(--mantine-radius-sm)",
                    borderLeft: isActive
                      ? "3px solid var(--mantine-color-brandPrimary-5)"
                      : "3px solid transparent",
                    minHeight: 38,
                    "&:hover": {
                      backgroundColor: isActive
                        ? "rgba(177, 54, 54, 0.15)"
                        : "rgba(255, 255, 255, 0.05)",
                    },
                  },
                }}
                py={6}
                px="sm"
              />
            );
          })}
        </div>
      ))}
    </>
  );
}
